import { Module } from '../utils/_application'
import { CountUp } from 'countup.js'

const $ = jQuery

export default class Counter extends Module {
  ready (app) {
    setTimeout(() => {
      const COUNTER_WRAPPERS = document.querySelectorAll('.mtt-item-counter')
      if (COUNTER_WRAPPERS.length > 0) {
        for (let i = 0; i < COUNTER_WRAPPERS.length; i++) {
          new MTTCounter(COUNTER_WRAPPERS[i])
        }
      }
    }, 10)
  }
}

class MTTCounter {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.COUNTER_ITEMS = this.WRAPPER.querySelectorAll('.mtt-item-counter__number')
    this.COUNTERS = []

    // create counters
    if (this.COUNTER_ITEMS.length) {
      for (let i = 0; i < this.COUNTER_ITEMS.length; i++) {
        const COUNTER_ITEM = this.COUNTER_ITEMS[i]
        const number = COUNTER_ITEM.innerHTML
        const options = { separator: ',', decimal: '.', startVal: 0, duration: 4 }
        options.decimalPlaces = (number % 1 != 0) ? 1 : 0

        this.setContainerWidth(this.COUNTER_ITEMS[i].parentElement)
          .then(() => this.createCounter(COUNTER_ITEM, number, options))
      }
    }

    let loadRan = false

    if (this.enterViewport(this.WRAPPER) && !loadRan && this.COUNTERS.length > 0) {
      loadRan = true
      for (let i = 0; i < this.COUNTERS.length; i++) {
        const COUNTER = this.COUNTERS[i]
        !COUNTER.error ? COUNTER.start() : ''
      }
    } else {
      setTimeout(() => {
        if (this.enterViewport(this.WRAPPER) && !loadRan && this.COUNTERS.length > 0) {
          loadRan = true
          for (let i = 0; i < this.COUNTERS.length; i++) {
            const COUNTER = this.COUNTERS[i]
            !COUNTER.error ? COUNTER.start() : ''
          }
        }
      }, 500)
    }

    // scroll event
    let ran = false
    window.addEventListener('scroll', () => {
      if (this.enterViewport(this.WRAPPER) && !ran && this.COUNTERS.length > 0) {
        ran = true
        for (let i = 0; i < this.COUNTERS.length; i++) {
          const COUNTER = this.COUNTERS[i]
          !COUNTER.error ? COUNTER.start() : ''
        }
      }
    })
  }

  /**
     * Set width of container to prevent animation flicker for text
     * @param {Object} element
     */
  setContainerWidth (element) {
    return new Promise((resolve) => {
      const width = element.getBoundingClientRect().width
      element.style.width = width + 'px'
      setTimeout(() => resolve(), 300)
    })
  }

  /**
     * Create counter
     * @param {Object} element
     * @param {Integer} number
     * @param {Object} options
     */
  createCounter (element, number, options) {
    const counter = new CountUp(element, number, options)
    this.COUNTERS.push(counter)
  }

  /**
     * Check if element is entering viewport
     * @param {Object} el
     */
  enterViewport (el) {
    if (!el) return false
    const BOUNDING = el.getBoundingClientRect()
    if (BOUNDING.top < this.getWindowHeight()) {
      return true
    }
    return false
  }

  getWindowHeight () {
    return (window.innerHeight || document.documentElement.clientHeight || 0)
  }
}
